var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoomService = function SvgRoomService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.005 17.008h2.334c.433 0 .854-.14 1.2-.4l2.418-1.813a1.516 1.516 0 0 1 1.98 2.284l-2.073 2.074c-.559.559-1.27.94-2.045 1.094l-2.931.587a4.002 4.002 0 0 1-1.756-.043L9.48 20.13a3.956 3.956 0 0 0-.97-.12H7.003m6.004-3.002h1.486c.837 0 1.516-.678 1.516-1.515v-.3c0-.695-.473-1.301-1.148-1.47l-2.293-.573a4.691 4.691 0 0 0-3.746.646l-1.817 1.212h-4v4.999h4M4 9h16m-2 0A6 6 0 0 0 6 9h12Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgRoomService;